<template>
    <div class="ibanner">
        <div class="ibanner-c">
            <!-- background: url(../images/product/product1-banner.jpg);
    background-size: cover; -->
            <el-carousel width="" height="" arrow="hover">
                <el-carousel-item v-for="(item,index) in bannerList" :key="index">
                    <!-- <img class="pic" :style="{background:'url(item.content)',background-size:'cover'}"> -->
                    <a :href="item.hyperLinks" target="_blank" rel="noopener noreferrer"><div class="pic" :style="{backgroundImage:'url('+item.content+')',backgroundSize:'cover',backgroundPosition:'center'}"></div></a>
                    
                </el-carousel-item>
            </el-carousel>
        </div>
       
    </div>
</template>

<script>
    export default {
        name: "banner",
        data () {
            return {
                headlineList:[],
                bannerList:[],
            };
        },
        methods: {
            toPlayer(code,id){
                sessionStorage.setItem('tabIndex',0);
                this.$router.push({
                    path: '/courseplayer',
                    query: {
                        code,
                        // id,
                    }
                })
            },
        },
        created(){
            //banner列表
            this.$axios.get("/v1/cloud/common/sys/rotation-picture"
            ).then(({data})=>{
                if(data){
                    this.bannerList = data;
                }
                console.log(55,data);
            }).catch(error=>{
                this.$message({
                    message: error.response.data.message,
                    type: 'warning'
                });
            })


            
        },
        mounted(){
            
        }
    }
</script>

<style lang="less">
    img{display:block;width:100%;height:100%;}
    .ibanner{
        width:100%;
        margin:0 auto !important;
        // padding:0px 0 14px 0;
        overflow: hidden;
        .ibanner-c{
            width:100%;
            // height:auto;
            height:500px;
            background:#2c7be0;
            margin:0 auto;
            // width:1200px;
            width:100%;

            
            img{
                display:block;width:100%;height:500px;
            }
            .pic{width:100%;height:100%;}
            .el-carousel__container{height:500px}
            .el-carousel__button{
                width:10px;height:10px;border-radius:50%;
            }
            .el-carousel__arrow{
                background-color: rgba(0,0,0,0,0);font-size:60px;opacity:0.3;
            }
            .el-carousel__arrow--right{right:100px;}
            .el-carousel__arrow--left{left:100px;}
        }
       
       
    }
</style>